import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n'; // TODO: get rid of this import

import { LinesRatingComponent } from './lines-rating.component';

@NgModule({
  declarations: [LinesRatingComponent],
  exports: [LinesRatingComponent],
  imports: [CommonModule, I18nModule],
})
export class LinesRatingModule {}
export { LinesRatingComponent } from './lines-rating.component';
